import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWarningCircleLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8 1.5C4.40991 1.5 1.5 4.40991 1.5 8C1.5 11.5894 4.40987 14.5 8 14.5C11.5901 14.5 14.5 11.5894 14.5 8C14.5 4.40991 11.5901 1.5 8 1.5ZM2.5 8C2.5 4.9622 4.9622 2.5 8 2.5C11.0378 2.5 13.5 4.9622 13.5 8C13.5 11.0372 11.0378 13.5 8 13.5C4.96223 13.5 2.5 11.0372 2.5 8ZM8.4974 5.53776C8.4974 5.26162 8.27354 5.03776 7.9974 5.03776C7.72125 5.03776 7.4974 5.26162 7.4974 5.53776V8.40413C7.4974 8.68028 7.72125 8.90413 7.9974 8.90413C8.27354 8.90413 8.4974 8.68028 8.4974 8.40413V5.53776ZM8.49993 10.4627C8.49993 10.1866 8.27607 9.96273 7.99993 9.96273C7.72379 9.96273 7.49993 10.1866 7.49993 10.4627V10.4945C7.49993 10.7707 7.72379 10.9945 7.99993 10.9945C8.27607 10.9945 8.49993 10.7707 8.49993 10.4945V10.4627Z",
		fill: "currentColor"
	})
});
export default SvgWarningCircleLine;
